import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from 'exceljs';
import * as fs from 'file-saver';
import * as moment from 'moment';
// tslint:disable-next-line: max-line-length
import { ReportTerminals, emptyFields, UsersType, gstColumnName } from './../utilities/common-file';
import {countries} from '../utilities/countries';
import { Injectable } from '@angular/core';
import { CommonService } from '../utilities/common-service';
import { AuthService } from '../auth/auth.service';
import { encryptStorage } from 'src/app/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  constructor(private commonService: CommonService, private authService: AuthService) {}
startDateForReport: any;
endDateForReport: any;
reportTerminals = ReportTerminals;
emptyField = emptyFields;
countries = countries;
showFields = false;
selectedTransaction: any;
gst:any;
hst:any;
gstColumnName = gstColumnName;
columnName :any;

addNewRow(worksheet) {
    worksheet.addRow([]);
  }
  addUsersHeaders(header: any) {
    const headers = header;
    return headers;
  }
  onDownloadExcel(header, title, startDate, endDate, data, fileName, reportTerminal, filterHeaders, filterData,gridFooter?,footerData?) {

    // this.toastr.success("Please Wait...Excel Exporting");
    const normalFont = { name: 'Times New Roman', size: 12, bold: true };

    // Create workbook and worksheet
    const workbook: ExcelProper.Workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet('MERCHANT BOARD');

    this.addNewRow(worksheet);
    this.hst = (localStorage.getItem('hst') === "true");
    this.gst = (localStorage.getItem('gst') === "true");
    if(this.gst && this.hst){
      this.columnName = this.gstColumnName.hst;
      }
      if(this.gst && !this.hst){
      this.columnName = this.gstColumnName.gst;
      }
    // For filters
    if (filterHeaders.length > 0 && filterData.length > 0) {
      // tslint:disable-next-line: variable-name
      worksheet.addRow(this.addUsersHeaders(filterHeaders)).eachCell((cell, number) => {
        // tslint:disable-next-line: triple-equals
        if (number == 2) {
          cell.alignment = { horizontal: 'left' };
        }
        cell.font = normalFont;
      });

      worksheet.addRow(filterData);
    }
    this.addNewRow(worksheet);
    // tslint:disable-next-line: variable-name
    worksheet.addRow(this.addUsersHeaders(header)).eachCell((cell, number) => {
      // tslint:disable-next-line: triple-equals
      if (number == 2) {
        cell.alignment = { horizontal: 'left' };
      }
      cell.font = normalFont;
    });

    this.showFields = this.authService.showOptionsBasedOnUserType();

    // Transactions Report

    // tslint:disable-next-line: max-line-length
    if (reportTerminal === this.reportTerminals.merchantTransactionReport) {
      let transactionType = '';
      let mobileNo = '';
      let currencySymbol = '';
      let settlementStatus = '';
      let displayName = '';   
      for (const obj of data) {
        //Displayname Changes based on narration
        if(this.getUserNameForPaynow(obj.narration)){
          displayName = obj.username ? obj.username:emptyFields.NA
        }else{
          displayName =  obj.user.displayName ? obj.user.displayName : emptyFields.NA
        }
        if (obj.transactionType) {
          transactionType = this.getTransactionType(obj.accountType);
       } else {
        transactionType = emptyFields.NA;
       }
        if (obj.user && obj.user.role === UsersType.appUser) {
          mobileNo = '+' + obj.user.countryCode + obj.user.mobileNo;
       } else {
          mobileNo =  emptyFields.NA;
       }
        if (obj.currency) {
        currencySymbol = this.getCurrency(obj.currency);
       } else {
        currencySymbol = '';
       }
        if (obj.isSettled) {
        settlementStatus = 'Settled';
       } else {
        settlementStatus = 'Un Settled';
       }
        if (this.showFields) {
          worksheet.addRow([obj.id ? obj.id : emptyFields.NA,
            obj.transaction && obj.transaction.documentNumber ? obj.transaction.documentNumber : emptyFields.NA,
            obj.userWallet && obj.userWallet.accountNo ? obj.userWallet.accountNo : emptyFields.NA,
             mobileNo,
             displayName,
             obj.location && obj.location.name ? obj.location.name : emptyFields.NA,
             obj.amount,
             obj.transactionFee,
             obj.bankFee,
             obj.netAmount,
             obj.paymentMethod ? obj.paymentMethod : emptyFields.NA,
             transactionType,
             settlementStatus,
             obj.narration ? obj.narration : emptyFields.NA,
             obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
             obj.user && obj.user.displayName ? obj.user.displayName : emptyFields.NA,
            ]);
        } else {
          worksheet.addRow([obj.id ? obj.id : emptyFields.NA,
            obj.transaction && obj.transaction.documentNumber ? obj.transaction.documentNumber : emptyFields.NA,
            obj.userWallet && obj.userWallet.accountNo ? obj.userWallet.accountNo : emptyFields.NA,
             mobileNo,
             obj.user.displayName ? obj.user.displayName : emptyFields.NA,
             obj.location && obj.location.name ? obj.location.name : emptyFields.NA,
             obj.amount,
             transactionType,
             settlementStatus,
             obj.narration ? obj.narration : emptyFields.NA,
             obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
             obj.user && obj.user.displayName ? obj.user.displayName : emptyFields.NA,
            ]);
        }
        //worksheet.getColumn(6).numFmt = '0.00';
        if (this.showFields) {
          worksheet.getColumn(7).numFmt = '0.00';
          worksheet.getColumn(8).numFmt = '0.00';
          worksheet.getColumn(9).numFmt = '0.00';
        }
      }
      if (gridFooter.length > 0 && footerData.length > 0) {
        this.addNewRow(worksheet);
        for(let i=0;i<=gridFooter.length;i++){
          worksheet.addRow([gridFooter[i],footerData[i]]);
        }
        worksheet.getColumn(2).alignment = { horizontal: 'left' };
      }
    }
    
    // Transactions Report New

    // tslint:disable-next-line: max-line-length
    if (reportTerminal === this.reportTerminals.merchantTransactionReportNew) {
      let transactionType = '';
      let userMobileNo = '';
      let currencySymbol = '';
      let settlementStatus = '';
      let displayName = '';   
      for (const obj of data) {
        //Displayname Changes based on narration
        if(this.getUserNameForPaynow(obj.narration)){
          displayName = obj.userFullName ? obj.userFullName:emptyFields.NA
        }else{
          displayName =  obj.userDisplayName ? obj.userDisplayName : emptyFields.NA
        }
        if (obj.transactionType) {
          transactionType = this.getTransactionType(obj.accountType);
       } else {
        transactionType = emptyFields.NA;
       }
        if (obj.role === UsersType.appUser) {
          userMobileNo = '+' + obj.userCountryCode + obj.userMobileNo;
       } else {
        userMobileNo =  emptyFields.NA;
       }
        if (obj.currency) {
        currencySymbol = this.getCurrency(obj.currency);
       } else {
        currencySymbol = '';
       }
        if (obj.isSettled) {
        settlementStatus = 'Settled';
       } else {
        settlementStatus = 'Un Settled';
       }
        if (this.showFields && this.gst) {
          worksheet.addRow([obj.id ? obj.id : emptyFields.NA,
            obj.transactionDocumentNumber && obj.transactionDocumentNumber ? obj.transactionDocumentNumber : emptyFields.NA,
            obj.walletAccountNo && obj.walletAccountNo ? obj.walletAccountNo : emptyFields.NA,
            userMobileNo,
             displayName,
             obj.merchantLocationName && obj.merchantLocationName? obj.merchantLocationName : emptyFields.NA,
             obj.settlementDocId ? obj.settlementDocId: emptyFields.NA,
             obj.amount,
             obj.transactionFee,
             obj.flexmGst,
             obj.totalFlexmFee,
             obj.commission,
             obj.gstCommission,
             obj.totalCommission,  
            //  obj.bankFee,
             obj.netAmount,
             obj.paymentMethod ? obj.paymentMethod : emptyFields.NA,
             transactionType,
             settlementStatus,
             obj.narration ? obj.narration : emptyFields.NA,
             obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
             obj.createdByFullName && obj.createdByFullName ? obj.createdByFullName : emptyFields.NA,
            ]);
        } else {
          worksheet.addRow([obj.id ? obj.id : emptyFields.NA,
            obj.transactionDocumentNumber && obj.transactionDocumentNumber ? obj.transactionDocumentNumber : emptyFields.NA,
            obj.walletAccountNo && obj.walletAccountNo ? obj.walletAccountNo : emptyFields.NA,
            userMobileNo,
             obj.userDisplayName ? obj.userDisplayName: emptyFields.NA,
             obj.merchantLocationName && obj.merchantLocationName ? obj.merchantLocationName : emptyFields.NA,
             obj.settlementDocId ? obj.settlementDocId: emptyFields.NA,
             obj.amount,
             obj.paymentMethod ? obj.paymentMethod : emptyFields.NA,
             transactionType,
             settlementStatus,
             obj.narration ? obj.narration : emptyFields.NA,
             obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
             obj.createdByFullName && obj.createdByFullName ? obj.createdByFullName : emptyFields.NA,
            ]);
        }
        //worksheet.getColumn(6).numFmt = '0.00';
        if (this.showFields) {
          //worksheet.getColumn(7).numFmt = '0.00';
          worksheet.getColumn(8).numFmt = '0.00';
          worksheet.getColumn(9).numFmt = '0.00';
        }
      }
      if (gridFooter.length > 0 && footerData.length > 0) {
        this.addNewRow(worksheet);
        for(let i=0;i<=gridFooter.length;i++){
          worksheet.addRow([gridFooter[i],footerData[i]]);
        }
        worksheet.getColumn(2).alignment = { horizontal: 'left' };
      }
    }
        // Settlement Document
    if (reportTerminal === this.reportTerminals.merchantSettlementReport) {
          const dataArray = data;
          let currencySymbol = '';
          let status = '';
          let userType = '';
          for (const obj of data) {
            if (obj.currency) {
              currencySymbol = this.getCurrency(obj.currency);
             } else {
              currencySymbol = '';
             }
            status = this.getSettlementDocumentStatus(obj.settlementStatus);
            userType = this.getUsersType(obj.createdByUser.role);
            if(this.gst){
              worksheet.addRow([
                obj.id,
                obj.settlementDocNo ? obj.settlementDocNo:emptyFields.NA,
                obj.merchant && obj.merchant.name ? obj.merchant.name : '',
                obj.location && obj.location.name ? obj.location.name : 'ALL',
                status,
                userType,
                obj.amount,
                obj.transactionFee,
                obj.flexmGst,
                obj.totalFlexmFee,
                obj.commission,
                obj.gstCommission,
                obj.totalCommission,
                obj.bankFee,
                obj.netAmount,
                obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
                obj.createdByUser && obj.createdByUser.displayName ? obj.createdByUser.displayName: emptyFields.NA,
                obj.updatedDate ? moment(obj.updatedDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
                obj.updatedByUser && obj.updatedByUser.displayName ? obj.updatedByUser.displayName: emptyFields.NA,
              ]);
            }else{
              worksheet.addRow([
                obj.id,
                obj.settlementDocNo ? obj.settlementDocNo:emptyFields.NA,
                obj.merchant && obj.merchant.name ? obj.merchant.name : '',
                obj.location && obj.location.name ? obj.location.name : 'ALL',
                status,
                userType,
                obj.amount,
                obj.transactionFee,
                 obj.commission,
                obj.gstCommission,
                obj.totalCommission,
                obj.bankFee,
                obj.netAmount,
                obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
                obj.createdByUser && obj.createdByUser.displayName ? obj.createdByUser.displayName: emptyFields.NA,
                obj.updatedDate ? moment(obj.updatedDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
                obj.updatedByFullName && obj.updatedByFullName ? obj.updatedByFullName: emptyFields.NA,
              ]);
            }
           
            worksheet.getColumn(5).numFmt = '0.00';
            worksheet.getColumn(6).numFmt = '0.00';
            worksheet.getColumn(7).numFmt = '0.00';
            worksheet.getColumn(8).numFmt = '0.00';
          }
          this.addNewRow(worksheet);
          let totalTransactionAmount = 0;
          let bankFee = 0;
          let transactionFee = 0;
          let netAmount = 0;
          for (const obj of dataArray) {
            totalTransactionAmount += obj.amount;
            bankFee += obj.bankFee;
            transactionFee += obj.transactionFee;
            netAmount += (obj.netAmount);
          }
          if (gridFooter.length > 0 && footerData.length > 0) {
            this.addNewRow(worksheet);
            for (let i = 0; i <= gridFooter.length; i++) {
              worksheet.addRow([gridFooter[i], footerData[i]]);
            }
            worksheet.getColumn(2).alignment = { horizontal: 'left' };
          }
          //worksheet.addRow(['Total Records',footerData[0]]);
          // worksheet.addRow(['Total Settlement Amount', totalTransactionAmount]).numFmt = '0.00';
          // worksheet.addRow(['Total Transaction Fee', transactionFee]).numFmt = '0.00';
          // worksheet.addRow(['Total Bank Fee', bankFee]).numFmt = '0.00';
          // worksheet.addRow(['Net Amount Transferred', netAmount]).numFmt = '0.00';
        }
     // Settlement Transactions
    if (reportTerminal === this.reportTerminals.settledTransactions) {
      let currencySymbol = '';
      let transactionType = '';
      for (const obj of data) {
        if (obj.currency) {
          currencySymbol = this.getCurrency(obj.currency);
         } else {
          currencySymbol = '';
         }
        if (obj.transactionType) {
          transactionType = this.getTransactionType(obj.accountType);
       } else {
        transactionType = emptyFields.NA;
       }
        worksheet.addRow([
          obj.id,
          obj.username ? obj.username : emptyFields.NA,
          obj.amount,
          obj.transactionFee,
          obj.flexmGst,
          obj.totalFlexmFee,
          obj.commission,
          obj.gstCommission,
          obj.totalCommission,
          obj.bankFee,
          obj.netAmount,
          transactionType,
          obj.narration,
          obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
        ]);
        worksheet.getColumn(3).numFmt = '0.00';
        worksheet.getColumn(4).numFmt = '0.00';
        worksheet.getColumn(5).numFmt = '0.00';
        worksheet.getColumn(6).numFmt = '0.00';
      }
      this.addNewRow(worksheet);
      if (this.selectedTransaction) {
        if (gridFooter.length > 0 && footerData.length > 0) {
          this.addNewRow(worksheet);
          for (let i = 0; i <= gridFooter.length; i++) {
            worksheet.addRow([gridFooter[i], footerData[i]]);
          }
          worksheet.getColumn(2).alignment = { horizontal: 'left' };
        }
  
        // worksheet.addRow(['Settlement No',this.selectedTransaction.id]);
        // worksheet.addRow(['Total Settlement Amount', (this.selectedTransaction.amount)]).numFmt = '0.00';
        // worksheet.addRow(['Total Transaction Fee', (this.selectedTransaction.transactionFee)]).numFmt = '0.00';
        // worksheet.addRow(['Total Bank Fee', (this.selectedTransaction.bankFee)]).numFmt = '0.00';
        // worksheet.addRow(['Net Amount Transferred', (this.selectedTransaction.netAmount)]).numFmt = '0.00';
      }

    }
     // Merchant Product Report
     if (reportTerminal === this.reportTerminals.merchantProductReport) {
      for (const obj of data) {
         // tslint:disable-next-line: max-line-length
        worksheet.addRow([obj.id ? obj.id : emptyFields.NA,
        obj.name ? obj.name : emptyFields.NA,
        obj.code ? obj.code : emptyFields.NA,
        //obj.merchantName ? obj.merchantName : emptyFields.NA,
        obj.productCategory ? obj.productCategory : emptyFields.NA,
        obj.description ? obj.description : emptyFields.NA,
        obj.additionalNotes ? obj.additionalNotes : emptyFields.NA,
        obj.price ? obj.price : emptyFields.NA,
        obj.status ?  this.getStatus(obj.status) : emptyFields.NA,
        obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
        obj.createdByUser && obj.createdByUser.displayName ? obj.createdByUser.displayName : emptyFields.NA,
        obj.updatedDate ? moment(obj.updatedDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
        obj.updatedByUser && obj.updatedByUser.displayName ? obj.updatedByUser.displayName : emptyFields.NA,
         ]);
        worksheet.getColumn(7).numFmt = '0.00';
      }
    }
    // Merchant Order details
    if (reportTerminal === this.reportTerminals.merchantOrderDetails) {
      let currency = encryptStorage.getItem('currencySymbol');
      for (const obj of data) {
         // tslint:disable-next-line: max-line-length
        worksheet.addRow([obj.id ? obj.id : emptyFields.NA,
        obj.orderNumber ? obj.orderNumber : emptyFields.NA,
        obj.accountNo ? obj.accountNo : emptyFields.NA,
        obj.mobileNo ? '+'+ obj.countryCode+obj.mobileNo : emptyFields.NA,
        obj.displayName ? obj.displayName : emptyFields.NA,
        obj.location ? obj.location.name: emptyFields.NA,
        obj.totalQuantity ? obj.totalQuantity : emptyFields.NA,
        obj.totalPrice ? currency+' '+obj.totalPrice : currency+' '+0,
        obj.taxAmount ? currency +' '+obj.taxAmount:currency+' '+0,
        obj.discountAmount ? currency+' '+obj.discountAmount : currency+' '+0,
        obj.netAmount ?currency+' '+obj.netAmount : currency+' '+0,
        obj.orderStatus ?  this.getOrderStatus(obj.orderStatus) : emptyFields.NA,
        obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
        obj.createdByUser && obj.createdByUser.displayName ? obj.createdByUser.displayName : emptyFields.NA,
        obj.updatedDate ? moment(obj.updatedDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
        obj.updatedByUser && obj.updatedByUser.displayName ? obj.updatedByUser.displayName : emptyFields.NA,
         ]);
        //worksheet.getColumn(7).numFmt = '0.00';
      }
    }

     // merchantRequestedPaymentList 

     if (reportTerminal === this.reportTerminals.merchantRequestedPaymentList ) {
      for (const obj of data) {
         // tslint:disable-next-line: max-line-length
        worksheet.addRow([obj.id ? obj.id : emptyFields.NA,
        obj.orderNo ? obj.orderNo : emptyFields.NA,
        obj.paymentId ? obj.paymentId : emptyFields.NA,
        obj.amount ? obj.amount : emptyFields.NA,
        obj.paymentMethod ? obj.paymentMethod : emptyFields.NA,
        obj.status ?  this.getMrechantPaymentTypeStatus(obj.status) : emptyFields.NA,
        obj.expiryTime ? moment(obj.expiryTime).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
        obj.customerName ? obj.customerName : emptyFields.NA,
        obj.phoneNumber ? obj.phoneNumber : emptyFields.NA,
        obj.email ? obj.email : emptyFields.NA,
        obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
        obj.createdByUser && obj.createdByUser.displayName ? obj.createdByUser.displayName : emptyFields.NA,
        obj.updatedDate ? moment(obj.updatedDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
        obj.updatedByUser && obj.updatedByUser.displayName ? obj.updatedByUser.displayName : emptyFields.NA,
         ]);
        worksheet.getColumn(7).numFmt = '0.00';
      }
    }

            // Merchant Daily Summary
    if (reportTerminal === this.reportTerminals.merchantDailySummary) {
              for (const obj of data) {
                if(this.gst){
                  worksheet.addRow([
                    obj.locationName ? obj.locationName : emptyFields.NA,
                    obj.transactionCount,
                    obj.calculatedTotalAmount,
                    obj.calculatedTransactionFee,
                    obj.calculatedFlexmGst,
                    obj.calculatedTotalFlexmFee,
                    obj.netAmountTransfer,
                    obj.transactionDate,
                  ]);
                }else{
                  worksheet.addRow([
                    obj.locationName ? obj.locationName : emptyFields.NA,
                    obj.transactionCount,
                    obj.calculatedTotalAmount,
                    obj.calculatedTransactionFee,
                    obj.netAmountTransfer,
                    obj.transactionDate,
                  ]);
                }
                    worksheet.getColumn(3).numFmt = '0.00';
                    worksheet.getColumn(4).numFmt = '0.00';
                    worksheet.getColumn(5).numFmt = '0.00';
                  }
                   if (gridFooter.length > 0 && footerData.length > 0) {
                    this.addNewRow(worksheet);
                    for(let i=0;i<=gridFooter.length;i++){
                      worksheet.addRow([gridFooter[i],footerData[i]]);
                    }
                    worksheet.getColumn(2).alignment = { horizontal: 'left' };
                  }
      }

        // Redeemed Voucher Report (without location column) 

    if (reportTerminal === this.reportTerminals.redeemedVoucherReport) {
      for (const obj of data) {
        worksheet.addRow([obj.code ? obj.code : emptyFields.NA,
        obj.voucherName ? obj.voucherName : emptyFields.NA,
        obj.voucherPurchaseType ? this.getVoucherPurchaseType(obj.voucherPurchaseType) : emptyFields.NA,
        obj.mobileNo ? obj.countryCode+'-'+obj.mobileNo : emptyFields.NA,
        obj.displayName ? obj.displayName : emptyFields.NA,
        obj.redeemedLocationName ? obj.redeemedLocationName : emptyFields.NA,
        obj.voucherValue ? this.getVoucherValue(obj.voucherValue,obj.voucherPurchaseType,obj.voucherCurrency) : emptyFields.NA,
        obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
        obj.createdByFullName && obj.createdByFullName ? obj.createdByFullName : emptyFields.NA,
        obj.updatedDate ? moment(obj.updatedDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
        obj.updatedByFullName && obj.updatedByFullName ? obj.updatedByFullName : emptyFields.NA,
        ]);
      }
    }

           // Redeemed Voucher Report (without location column) 

           if (reportTerminal === this.reportTerminals.redeemedVoucherReport2) {
            for (const obj of data) {
              worksheet.addRow([obj.code ? obj.code : emptyFields.NA,
                obj.voucherName ? obj.voucherName : emptyFields.NA,
                obj.voucherPurchaseType ? this.getVoucherPurchaseType(obj.voucherPurchaseType) : emptyFields.NA,
                obj.mobileNo ? obj.countryCode+'-'+obj.mobileNo : emptyFields.NA,
                obj.displayName ? obj.displayName : emptyFields.NA,
                obj.voucherValue ? this.getVoucherValue(obj.voucherValue,obj.voucherPurchaseType,obj.voucherCurrency) : emptyFields.NA,
                obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
                obj.createdByFullName && obj.createdByFullName ? obj.createdByFullName : emptyFields.NA,
                obj.updatedDate ? moment(obj.updatedDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
                obj.updatedByFullName && obj.updatedByFullName ? obj.updatedByFullName : emptyFields.NA,
              ]);
            }
          }


    if (reportTerminal === this.reportTerminals.merchantTransactionsForSummary) {
        let transactionType = '';
        let userMobileNo = '';
        for (const obj of data) {
          if (obj.transactionType) {
            transactionType = this.commonService.getTransactionAccountType(obj.accountType);
         } else {
          transactionType = emptyFields.NA;
         }
         if (obj.role === UsersType.appUser) {
          userMobileNo = '+' + obj.userCountryCode + obj.userMobileNo;
       } else {
        userMobileNo =  emptyFields.NA;
       }

              // tslint:disable-next-line: max-line-length
          worksheet.addRow([obj.id ? obj.id : emptyFields.NA,
            obj.walletAccountNo && obj.walletAccountNo ? obj.walletAccountNo : emptyFields.NA,
             userMobileNo,
             obj.userDisplayName ? obj.userDisplayName: emptyFields.NA,
             obj.merchantLocationName && obj.merchantLocationName ? obj.merchantLocationName : emptyFields.NA,
              obj.amount,
              obj.transactionFee,
              obj.netAmount,
              transactionType,
              obj.narration ? obj.narration : emptyFields.NA,
              obj.createdDate ? moment(obj.createdDate).local().format('DD-MMM-YYYY hh:mm:A') : emptyFields.NA,
              obj.createdByFullName && obj.createdByFullName ? obj. createdByFullName: emptyFields.NA,
             ]);
          worksheet.getColumn(6).numFmt = '0.00';
          worksheet.getColumn(7).numFmt = '0.00';
          worksheet.getColumn(8).numFmt = '0.00';
        }
        if (gridFooter.length > 0 && footerData.length > 0) {
          this.addNewRow(worksheet);
          for(let i=0;i<=gridFooter.length;i++){
            worksheet.addRow([gridFooter[i],footerData[i]]);
          }
          worksheet.getColumn(2).alignment = { horizontal: 'left' };
        }
      }
    worksheet.columns.forEach(column => {
      column.width = 30;
    });
    const fileNameForFile = fileName + '_' + moment().local().format('DDMMYYYYhhmmss') + '.xlsx';
    // tslint:disable-next-line: no-shadowed-variable
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, fileNameForFile);
    });
  }
  getStatus(status) {
    return this.commonService.getStatus(status);
  }
  getOrderStatus(status) {
    return this.commonService.getOrderStatus(status);
  }
  getTransactionType(type) {
    return this.commonService.getTransactionAccountType(type);
  }
  getMrechantPaymentTypeStatus(type) {
    return this.commonService.getMrechantPaymentTypeStatus(type);
  }
  getTier(tier) {
   return this.commonService.getTier(tier);
  }
  getSettlementDocumentStatus(status) {
    return this.commonService.getSettlementDocumentStatus(status);
  }
  getCurrency(currency) {
    return this.commonService.getCurrency(currency);
  }
  // To Show getVoucher Purchase Type 
  getVoucherPurchaseType(type) {
  return this.commonService.getVoucherPurchaseType(type);
  }

  // To Show get Voucher value
  getVoucherValue(voucherValue,purchaseType,currency) {
    if(this.getVoucherPurchaseType(purchaseType) == 'Price'){
    return ''+this.getCurrency(currency)+''+voucherValue;
    }else{
      return ''+voucherValue+'';
    }
    }


   // Get Details For Settlement Transactions

   setSettlementTransactionDetails(value) {
    this.selectedTransaction = value;
  }
  // Get Users Type
  getUsersType(type) {
    return this.commonService.getUsersType(type);
  }

  getUserNameForPaynow(narration: string) {
    var paynow;
    if(narration){
      paynow = narration.startsWith("Merchant Pay, Paynow") || narration.startsWith("Settlement");
      return paynow;
    }else{
      return false;
    }        
  }
}
